import { graphql } from "@/lib/gql/__generated__";

export const EcReceiptEmailResend_ECReceiptDetailPage_Mutation = graphql(`
	mutation EcReceiptEmailResend_ECReceiptDetailPage($input: ECReceiptEmailResendInput!) {
		ecReceiptEmailResend(input: $input) {
			userErrors
			receiptItem {
				id
				hotelID
				receiptID
				guestName
				guestNameKana
				guestEmail
				guestTel
				guestPostalCode
				guestAddress
				purchasedDate
				totalGuestCharge
				purchasedItems {
					name
					amount
					eachPrice
				}
			}
		}
	}
`);
